<div *ngIf="reportType == 'JahitatJamaReport'" class="report-wrapper">
    <div class="report-container" id="print-section">

        <div class="report-header">
            <div class="header-row">
                <div class="report-title">जाहिरात जमा - ({{ getMarathiYear() }})</div>
            </div>
        </div>

        <div class="table-container">
            <table class="report-table">
                <thead>
                    <tr class="table-header">
                        <th rowspan="2">अ.<br>क्र.</th>
                        <th rowspan="2" class="col-rep">प्रतिनिधी</th>
                        <th rowspan="2" class="col-type"></th>
                        <th *ngFor="let m of selectedMonths" colspan="2">{{ m.name }}</th>
                        <th colspan="2">एकूण</th>
                    </tr>
                    <tr class="table-header">
                        <ng-container *ngFor="let m of selectedMonths">
                            <th>जाहिरात</th>
                            <th>देणगी</th>
                        </ng-container>
                        <th>जाहिरात</th>
                        <th>देणगी</th>
                    </tr>
                </thead>
                <tbody *ngFor="let office of advtFormBeans; let i = index">
                    <!-- Row 1: जमा -->
                    <!-- Row 1: जमा -->
                    <tr>
                        <td rowspan="3" class="cell-center">{{ i + 1 }}</td>
                        <td rowspan="3" class="cell-rep">{{ office.office_rep }}</td>
                        <td class="cell-label">जमा</td>
                        <ng-container *ngFor="let m of selectedMonths">
                            <td class="cell-amount">{{ showValue(office.monthly_data[m.index]) }}</td>
                            <td class="cell-amount">{{ showValue(office.dngee_monthly[m.index]) }}</td>
                        </ng-container>
                        <td class="cell-amount">{{ showValue(office.total) }}</td>
                        <td class="cell-amount">{{ showValue(office.total_dngee) }}</td>
                    </tr>

                    <!-- Row 2: एकूण (जाहिरात + देणगी combined) -->
                    <tr>
                        <td class="cell-label">एकूण</td>
                        <ng-container *ngFor="let m of selectedMonths">
                            <td colspan="2" class="cell-amount">
                                {{ showValue(getMonthCombinedTotal(office, m.index)) }}
                            </td>
                        </ng-container>
                        <td colspan="2" class="cell-amount">{{ showValue(getOfficeGrandCombinedTotal(office)) }}</td>
                    </tr>

                    <!-- Row 3: उद्दीष्ट — one input per month, bound to correct month index -->
                    <tr>
                        <td class="cell-label">उद्दीष्ट</td>
                        <ng-container *ngFor="let m of selectedMonths">
                            <td colspan="2" class="cell-target">
                                <input type="number" [ngModel]="office.udhistha_monthly[m.index]"
                                    (ngModelChange)="office.udhistha_monthly[m.index] = $event"
                                    [ngModelOptions]="{standalone: true}" class="target-input"
                                    (blur)="saveUdhistha(office, m.index)" />
                            </td>
                        </ng-container>
                        <td colspan="2" class="cell-amount">--</td>
                    </tr>
                </tbody>

                <tfoot>
                    <!-- Footer Row 1: जमा totals -->
                    <tr class="footer-row">
                        <td rowspan="3" class="cell-center footer-label">एकूण</td>
                        <td rowspan="3" class="footer-label"></td>
                        <td class="cell-label footer-label">जमा</td>
                        <ng-container *ngFor="let m of selectedMonths">
                            <td class="cell-amount footer-label">{{ showValue(monthlyTotals[m.index]) }}</td>
                            <td class="cell-amount footer-label"></td>
                        </ng-container>
                        <td class="cell-amount footer-label">{{ showValue(grandTotal) }}</td>
                        <td class="cell-amount footer-label"></td>
                    </tr>

                    <!-- Footer Row 2: एकूण totals -->
                    <!-- Footer Row 2: एकूण totals (जाहिरात + देणगी combined) -->
                    <tr class="footer-row">
                        <td class="cell-label footer-label">एकूण</td>
                        <ng-container *ngFor="let m of selectedMonths">
                            <td colspan="2" class="cell-amount footer-label">
                                {{ showValue(monthlyTotals[m.index] + (monthlyDngeeTotals[m.index] || 0)) }}
                            </td>
                        </ng-container>
                        <td colspan="2" class="cell-amount footer-label">{{ showValue(grandTotal + grandDngeeTotal) }}
                        </td>
                    </tr>

                    <!-- Footer Row 3: उद्दीष्ट totals — pass m.index here -->
                    <tr class="footer-row">
                        <td class="cell-label footer-label">उद्दीष्ट</td>
                        <ng-container *ngFor="let m of selectedMonths">
                            <td colspan="2" class="cell-amount footer-label">
                                {{ showValue(getTotalUdhistha(m.index)) }}
                            </td>
                        </ng-container>
                        <td colspan="2" class="cell-amount footer-label">--</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons noPrint">
        <button class="btn btn-print" (click)="printPageA4Landscape()">🖨️ Print</button>
        <button class="btn btn-export" (click)="exportExcel('JahiratJama')">📥 Export</button>
        <button class="btn btn-close" mat-button mat-dialog-close>
            <mat-icon>close</mat-icon> Close
        </button>
    </div>
</div>